import { useMutation } from '@northladder/services';

import { BIDS_API } from '../bidsAPIClient';

/**
 * This is to track the update bid status mutation keys in react query cache.
 */
const MUT_UPLOAD_BID_BOOK = 'upload-bid-book-mutation-key';

/**
 * This performs a post request for uploading the bid book.
 */
export const useUploadBidBookMutation = () => {
  const {
    error,
    isError,
    isPending,
    mutate: callUploadBidBook,
  } = useMutation({
    mutationKey: [MUT_UPLOAD_BID_BOOK],
    networkMode: 'always', // Even make calls when offline
    mutationFn: BIDS_API.uploadBidBook,
  });

  return {
    callUploadBidBook,
    error,
    isError,
    isPending,
  };
};
